/**
 * PianoTell Recitals — Forum Entry Point
 *
 * Registers all forum-side features:
 * - Publish button and "Add to Recital" in post controls
 * - Reply enhancement on performance posts (includes piece in mention)
 * - Submission template auto-fill in submission threads
 * - Reserved slot event post renderer
 * - CSS to hide submission tags from navigation (they're internal workflow tags)
 */
import app from 'flarum/forum/app';
import addPublishButton from './addPublishButton';
import addCreateRecitalButton from './addCreateRecitalButton';
import addRecitalThreadActions from './addRecitalThreadActions';
import addAutoReplyTemplate from './addAutoReplyTemplate';
import addSubmissionTemplate from './addSubmissionTemplate';
import ReservedSlotPost from './components/ReservedSlotPost';
import Recital from '../common/models/Recital';
app.initializers.add('pianotell-recitals', () => {
  app.store.models.recitals = Recital;
  addPublishButton();
  addCreateRecitalButton();
  addRecitalThreadActions();
  addAutoReplyTemplate();
  addSubmissionTemplate();

  // Register the reservedSlot post type so Flarum renders it as an EventPost.
  // Without this, reserved slot posts would show as "[unknown]" in the stream.
  app.postComponents.reservedSlot = ReservedSlotPost;

  // Hide submission tags from the tag cloud/navigation after app boots.
  // These tags are internal workflow tags (e.g., "Recital Submission Open")
  // that shouldn't be browsable. Discussions with these tags remain visible
  // in All Discussions. We defer with setTimeout(0) because app.forum is
  // undefined during the initializer boot phase.
  setTimeout(function () {
    var types = app.forum.attribute('recitalsRecitalTypes') || [];
    if (!types.length) return;
    var tags = app.store.all('tags');
    var selectors = [];
    types.forEach(function (type) {
      var tagId = String(type.submission_tag_id);
      var tag = tags.find(function (t) {
        return String(t.id()) === tagId;
      });
      if (tag) {
        selectors.push('[href="/t/' + tag.slug() + '"]');
      }
    });
    if (selectors.length) {
      var style = document.createElement('style');
      style.setAttribute('data-recitals-hide-tags', '');
      style.textContent = '.TagCloud ' + selectors.join(', .TagCloud ') + ', ' + '.IndexPage-nav .item-nav ' + selectors.join(', .IndexPage-nav .item-nav ') + ' { display: none !important; }';
      document.head.appendChild(style);
    }
  }, 0);
});